export function initHeaderAnimation() {
  const header = document.querySelector('header');
  if (!header) return;

  const navDropdowns = header.querySelectorAll('nav');
  const desktopDropdownGroups = header.querySelectorAll('nav > div.group.relative');
  const toggleBtn = document.getElementById('mobile-menu-toggle');
  const dropdown = document.getElementById('mobile-nav-dropdown');
  const hamburgerIcon = document.getElementById('menu-icon-hamburger');
  const closeIcon = document.getElementById('menu-icon-close');

  if (!toggleBtn || !dropdown || !hamburgerIcon || !closeIcon) return;

  let isScrolled = window.scrollY > 30;
  let isHovered = false;
  let isMobileOpen = !dropdown.classList.contains('opacity-0');

  let currentState = false;
  let animatingTimeout;

  const resetDesktopDropdown = (dropdownGroup) => {
    dropdownGroup.removeAttribute('data-dropdown-dismissed');

    const flyout = dropdownGroup.querySelector(':scope > div');
    const panel = flyout?.querySelector(':scope > div');
    if (!flyout || !panel) return;

    flyout.style.visibility = '';
    flyout.style.pointerEvents = '';
    panel.style.visibility = '';
    panel.style.maxHeight = '';
    panel.style.transform = '';
    panel.style.opacity = '';
  };

  // Master function to evaluate header state
  const updateHeaderState = () => {
    const newState = isScrolled || isHovered || isMobileOpen;

    if (newState !== currentState) {
      currentState = newState;
      header.setAttribute('data-active', newState ? 'true' : 'false');

      header.classList.add('is-animating');

      clearTimeout(animatingTimeout);
      animatingTimeout = setTimeout(() => {
        header.classList.remove('is-animating');
      }, 600);
    }
  };

  window.addEventListener('scroll', () => {
    isScrolled = window.scrollY > 30;
    updateHeaderState();
  });

  navDropdowns.forEach((navGroup) => {
    navGroup.addEventListener('mouseenter', () => {
      isHovered = true;
      updateHeaderState();
    });

    navGroup.addEventListener('mouseleave', () => {
      isHovered = false;
      desktopDropdownGroups.forEach(resetDesktopDropdown);
      updateHeaderState();
    });
  });

  desktopDropdownGroups.forEach((dropdownGroup) => {
    dropdownGroup.addEventListener('mouseenter', () => {
      desktopDropdownGroups.forEach((otherDropdownGroup) => {
        if (otherDropdownGroup !== dropdownGroup) {
          otherDropdownGroup.querySelector('button')?.blur();
        }
      });
    });
  });

  const closeDesktopDropdowns = () => {
    isHovered = false;
    if (document.activeElement instanceof HTMLElement) {
      document.activeElement.blur();
    }
    desktopDropdownGroups.forEach((dropdownGroup) => {
      dropdownGroup.setAttribute('data-dropdown-dismissed', 'true');
      dropdownGroup.querySelector('button')?.blur();

      const flyout = dropdownGroup.querySelector(':scope > div');
      const panel = flyout?.querySelector(':scope > div');
      if (!flyout || !panel) return;

      flyout.style.visibility = 'hidden';
      flyout.style.pointerEvents = 'none';
      panel.style.visibility = 'hidden';
      panel.style.maxHeight = '0px';
      panel.style.transform = 'translateY(-1rem)';
      panel.style.opacity = '0';
    });
    updateHeaderState();
  };

  header.querySelectorAll('nav a[target="_blank"]').forEach((link) => {
    link.addEventListener('click', closeDesktopDropdowns);
  });

  window.addEventListener('blur', closeDesktopDropdowns);

  // Mobile Menu Toggle Controller
  toggleBtn.addEventListener('click', () => {
    const isHidden = dropdown.classList.contains('opacity-0');

    if (isHidden) {
      // Open menu
      dropdown.classList.remove('opacity-0', '-translate-y-4', 'pointer-events-none');
      dropdown.classList.add('opacity-100', 'translate-y-0', 'pointer-events-auto');
      hamburgerIcon.classList.replace('block', 'hidden');
      closeIcon.classList.replace('hidden', 'block');
      isMobileOpen = true;
    } else {
      // Close menu
      dropdown.classList.add('opacity-0', '-translate-y-4', 'pointer-events-none');
      dropdown.classList.remove('opacity-100', 'translate-y-0', 'pointer-events-auto');
      hamburgerIcon.classList.replace('hidden', 'block');
      closeIcon.classList.replace('block', 'hidden');
      isMobileOpen = false;

      // Auto-collapse inner accordions when main menu closes (scoped to mobile dropdown)
      dropdown.querySelectorAll('.accordion-content').forEach((el) => {
        el.style.maxHeight = '0px';
      });
      dropdown.querySelectorAll('.chevron-icon').forEach((el) => {
        el.classList.remove('rotate-180');
      });
      dropdown.querySelectorAll('.accordion-trigger').forEach((el) => {
        el.classList.remove('text-cake-blue');
      });
    }

    updateHeaderState();
  });

  // Inner Accordions Controller (Mobile - scoped to mobile dropdown)
  dropdown.querySelectorAll('.accordion-trigger').forEach((trigger) => {
    trigger.addEventListener('click', () => {
      const parent = trigger.parentElement;
      if (!parent) return;
      const content = parent.querySelector('.accordion-content');
      const chevron = trigger.querySelector('.chevron-icon');
      if (!content) return;
      const isOpen = content.style.maxHeight && content.style.maxHeight !== '0px';

      // Shut any other opened lists down (scoped to mobile dropdown with defensive null-checks)
      dropdown.querySelectorAll('.accordion-content').forEach((el) => {
        el.style.maxHeight = '0px';
        const elParent = el.parentElement;
        if (elParent) {
          const elChevron = elParent.querySelector('.chevron-icon');
          if (elChevron) {
            elChevron.classList.remove('rotate-180');
          }
          const elTrigger = elParent.querySelector('.accordion-trigger');
          if (elTrigger) {
            elTrigger.classList.remove('text-cake-blue');
          }
        }
      });

      // Open if it was previously closed
      if (!isOpen) {
        content.style.maxHeight = content.scrollHeight + 'px';
        if (chevron) {
          chevron.classList.add('rotate-180');
        }
        trigger.classList.add('text-cake-blue');
      }

      // Calculate precise target scroll position (sum of all preceding collapsed accordion trigger heights)
      const scrollContainer = dropdown.querySelector('.overflow-y-auto');
      if (scrollContainer) {
        let targetScrollTop = 0;
        let sibling = parent.previousElementSibling;
        while (sibling) {
          const siblingTrigger = sibling.querySelector('.accordion-trigger');
          if (siblingTrigger) {
            targetScrollTop += siblingTrigger.offsetHeight;
          }
          // Account for flex space-y-2 (8px) and border-b pb-2 (8px)
          targetScrollTop += 16;
          sibling = sibling.previousElementSibling;
        }

        scrollContainer.scrollTo({
          top: targetScrollTop,
          behavior: 'smooth',
        });
      }
    });
  });

  updateHeaderState();
}
